import {type FC} from "react";
import {CopyButton} from "./CopyButton";

type Props = {
    apiUrl: string;
};

/**
 * Shown once, right after an address is issued. Besides the address itself it
 * offers a ready request, because the first question after "here is your key"
 * is always "and how do I use it".
 */
export const IssuedKey: FC<Props> = (props) => {
    const {apiUrl} = props;
    const example = `curl "${apiUrl}" \\\n  -H "x-target-url: https://api.example.com/"`;

    return (
        <article className="issued">
            <header>{"Готовый адрес. Показывается один раз — сохраните его"}</header>

            <code className="key">{apiUrl}</code>
            <CopyButton value={apiUrl} label="Копировать адрес" />

            <details>
                <summary>{"Пример запроса"}</summary>
                <pre className="snippet">{example}</pre>
                <CopyButton value={example} label="Копировать команду" />
            </details>

            <small>
                {"Ключ уже внутри адреса. Целевой адрес передавайте заголовком "}
                <code>{"x-target-url"}</code>
                {". Relay готов в течение минуты."}
            </small>
        </article>
    );
};
